import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  output,
} from '@angular/core';

import {
  FormControlComponent,
  PrimengSelectDirective,
  SelectItem,
} from '@web/shared/ui';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { Nillable } from '@web/utils';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Select } from 'primeng/select';

type PublicSortPanelFormGroup<SortType> = FormGroup<{
  sort: FormControl<Nillable<SortType>>;
}>;

@Component({
  selector: 'app-public-sort-panel',
  imports: [
    FormControlComponent,
    PrimengSelectDirective,
    ReactiveFormsModule,
    Select,
  ],
  templateUrl: './public-sort-panel.component.html',
  styleUrl: './public-sort-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicSortPanelComponent<SortType> {
  private readonly builder = inject(FormBuilder);

  public readonly selectItems = input.required<SelectItem<SortType>[]>();

  /* prettier-ignore */
  public readonly sortTypeChange = output<Nillable<SortType>>();

  protected readonly form = this.buildForm();

  private destroyRef = inject(DestroyRef);

  public constructor() {
    this.listenToFormValueChanges();
  }

  private buildForm(): PublicSortPanelFormGroup<SortType> {
    return this.builder.group({
      sort: this.builder.control<Nillable<SortType>>(null),
    });
  }

  private listenToFormValueChanges(): void {
    this.form.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value) => this.sortTypeChange.emit(value.sort));
  }
}
